import wayIsOpenTicket from '../wayIsOpenTicket';
import tripSupportsSeatSelection from './tripSupportsSeatSelection';

export default (purchase, way = 'departs') => {
  const leg = purchase[way];
  return purchase.allowsSeatSelection && !wayIsOpenTicket(leg) && tripSupportsSeatSelection(leg);
};
